import { apiRequester } from "@engelvoelkersamericas/common-story-ui";
import axios from "axios";
const { detect } = require("detect-browser");
const browser = detect();

export const API =
  process.env.NODE_ENV === "production"
    ? `https://api.${window.location.hostname.split(".").slice(-2).join(".")}`
    : "";

// export const deployment =
//   process.env.NODE_ENV === "production"
//   ? `evipscloud`
//   : `ev-dev-qa`

export const deployment = window.location.hostname.includes("evipscloud") ? "evipscloud" : "ev-dev-qa";


export async function fetchApps() {
  try {
    const res = await apiRequester.get(`/apps/groups`);
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function fetchAffiliatons(profile) {
  let userId = profile ? profile.staffId : '';

  try {
    const res = await axios.get(`https://eva-personnel-service.${deployment}.com/users/${userId}/affiliations`, {
      withCredentials: true,
    })
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function fetchMe() {
  try {
    const res = await apiRequester.get(`/me`);
    return res.data;
  } catch (error) {
    console.log(error);
    throw Error("Failed to Fetch me");
  }
}

export async function fetchLogin(appName, relianceId, link, email, affiliationId, staffId) {
  // must open before ajax call so it doesn't get blocked for Safari
  let windowReference = null;

  const isPreOpen =
    browser.name === "safari" ||
    browser.name === "ios" ||
    browser.name === "ios-webview";
  if (isPreOpen) {
    windowReference = window.open();
  }

  try {
    if (appName.includes("cloud_cma")) {
      window.open(`${link}?email=${email}`,"_blank");
    } else if (appName === "evinsider_dashboard---1644877138118") {
      window.open(`${link}?email=${email}`,"_blank");
    } else if (appName === "brand_central") {
      //TODO:  Make this dynamic based on environment
      //TODO:  Add the cookie for secure requests
      //Get the request from our backend
      const response = await apiRequester.get(`https://eva-security-service.${deployment}.com/sso/brand-central/${affiliationId}`,
      {withCredentials:true,});

      // Create the form
      let brandCentralForm=document.createElement('FORM');
      brandCentralForm.name='myForm';
      brandCentralForm.method='POST';
      brandCentralForm.action=link;
      brandCentralForm.setAttribute("target", "_blank");
      brandCentralForm.setAttribute("id", "bcForm");

      // Add the SAMLResponse field
      let brandCentralInput=document.createElement('INPUT');
      brandCentralInput.type='HIDDEN';
      brandCentralInput.name='SAMLResponse';
      brandCentralInput.value=response.data;
      brandCentralForm.appendChild(brandCentralInput);

      // Add the RelayState
      brandCentralInput=document.createElement('INPUT');
      brandCentralInput.type='HIDDEN';
      brandCentralInput.name='RelayState';
      brandCentralInput.value='Notused';
      brandCentralForm.appendChild(brandCentralInput);

      // Add it to the dom
      document.body.appendChild(brandCentralForm);
      // Click the button
      brandCentralForm.submit();

      // Now clean it up.
      let elem = document.getElementById('bcForm')
      elem.remove();

    } else if (appName === "adwerx"){
      const res = await apiRequester.get(
        `/apps/${appName}/login${staffId ? `?staffid=${staffId}` : ""}`
      );
      if (res.data.redirectUrl) {
        if (windowReference) {
          windowReference.location = res.data.redirectUrl;
        } else {
            window.open(res.data.redirectUrl, "_blank");
        }
      }

      return;
    
    } else {
      const res = await apiRequester.get(
        `/apps/${appName}/login${relianceId ? `?relianceid=${relianceId}` : ""}`
      );
      if (res.data.redirectUrl) {
        if (windowReference) {
          windowReference.location = res.data.redirectUrl;
        } else {
          //window.open(res.data.redirectUrl, '_blank');
          if (appName === "brand_central") {
            window.open(res.data.redirectUrl, "_self");
          } else {
            window.open(res.data.redirectUrl, "_blank");
          }
        }
      }

      return;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchBanners() {
  const gql = String.raw;
  try {
    const res = await axios.post("https://cms.evipscloud.com/graphql", {
      query: gql`
        {
          ipsBanner {
            banners {
              image {
                url
              }
              active
              startDate
              endDate
              name
              linkedApp
              outsideLink
              countries {
                country
              }
            }
          }
        }
      `,
    });

    return res.data.data.ipsBanner.banners;
  } catch (error) {
    throw error;
  }
}

export async function fetchIpsSettings() {
  try {
    const res = await apiRequester.get("/settings/ips/layout");
    return res.data;
  } catch (error) {
    return null;
  }
}

export async function postIpsSettings(settings) {
  try {
    await apiRequester.put("/settings/ips/layout", settings);
  } catch (error) {}
}

export async function createTicket(subject, message, fromApp) {
  try {
    await apiRequester.post("/support/tickets", {
      subject,
      message,
      fromApp,
    });
  } catch (error) {
    throw error;
  }
}
